export const rooms = [
  {
    id: 1,
    name: 'Double Queen — Garden View',
    beds: '2 Queen Beds',
    rate: 'US$140 / night',
    description: 'Spacious room with two queen beds and direct views of the lush tropical gardens. Features Art Déco tile floors, custom Nicaraguan wood furniture, and en-suite bath.',
    image: 'https://montebrisa.com/wp-content/uploads/2023/07/habitacion-doble-queen-con-vista-al-jardin.jpg',
    amenities: ['2 Queen Beds', 'Garden View', 'En-Suite Bath', 'AC', 'Safe', 'WiFi'],
  },
  {
    id: 2,
    name: 'King — Garden View',
    beds: 'King Bed',
    rate: 'US$110 / night',
    description: 'Elegant king room framed by panoramic garden vistas. Sustainably harvested Nicaraguan wood furnishings and a serene en-suite bath make this a guest favourite.',
    image: 'https://montebrisa.com/wp-content/uploads/2023/07/habitacion-king-con-vista-al-jardin.jpg',
    amenities: ['King Bed', 'Garden View', 'En-Suite Bath', 'AC', 'Safe', 'WiFi'],
  },
  {
    id: 3,
    name: 'Queen — Balcony',
    beds: 'Queen Bed',
    rate: 'US$100 / night',
    description: 'Charming queen rooms with private balcony access overlooking the tropical grounds. Original Art Déco architectural details preserved throughout.',
    image: 'https://montebrisa.com/wp-content/uploads/2023/07/habitaciones-queen-con-balcon-scaled.jpg',
    amenities: ['Queen Bed', 'Private Balcony', 'En-Suite Bath', 'AC', 'Safe', 'WiFi'],
  },
  {
    id: 4,
    name: 'Queen — Interior',
    beds: 'Queen Bed',
    rate: 'US$90 / night',
    description: 'Intimate and quiet queen rooms facing the interior courtyard. Ideal for guests seeking total tranquility, with the same quality finishes as all rooms.',
    image: 'https://montebrisa.com/wp-content/uploads/2023/07/habitaciones-queen-de-interiores.jpg',
    amenities: ['Queen Bed', 'Courtyard View', 'En-Suite Bath', 'AC', 'Safe', 'WiFi'],
  },
];
